module.exports = __webpack_public_path__ + "static/media/sample.558f24ac.mp3";